const Menu = ((($) => {

  let menuClass;
  let hamburgerClass;
  let headerClass;

  function init() {
    hamburgerClass = $('.js-hamburger');
    menuClass = $('.Menu');
    headerClass = $('.Header');

    _toggleHamburger();
  }
  function _toggleHamburger() {
    hamburgerClass.click(_handleClickElement);

  }

  function _handleClickElement() {
    headerClass.toggleClass('show-menu');
    hamburgerClass.toggleClass('is-active');
    menuClass.toggleClass('show');
  }

  return {
    init,
  };
}))(jQuery);

export default Menu;



// WEBPACK FOOTER //
// ./src/static/js/modules/menu.js